<div *ngIf="parameterValue != 'individual'" class="partners">
  <!-- <img class="klogo" src="../../../assets/images/klogo.svg" /> -->
  <div class="partnersInner container">
    <h4 class="partnersTitle">
      <span style="color: #5800bf">Our Partners</span>
    </h4>

    <swiper
      style="
        --swiper-navigation-color: rgba(0, 0, 0, 0);
        --swiper-pagination-color: #fff;
      "
      loop="true"
      [navigation]="true"
      setWrapperSize="true"
      [autoplay]="{
        disableOnInteraction: false,
        delay: 1500
      }"
      [breakpoints]="{
        '1200': {
          slidesPerView: 5,
          spaceBetween: 50
        },

        '768': {
          slidesPerView: 5,
          spaceBetween: 50
        },
        '366': {
          slidesPerView: 4,
          spaceBetween: 20
        },
        '0': {
          slidesPerView: 4,
          spaceBetween: 20,
          setWrapperSize: true
        }
      }"
      class="mySwiper"
    >
      <ng-template swiperSlide>
        <img
          class="swiperimg webPic"
          src="../../../assets/images/newpartners/th__2_-removebg-preview 2.svg" />
        <img
          class="swiperimg mobilePic"
          src="../../../assets/images/newpartners/new/paytabs.png"
      /></ng-template>

      <ng-template swiperSlide>
        <img
          class="swiperimg"
          src="../../../assets/images/newpartners/NBE-logo 1.svg"
      /></ng-template>

      <!-- paynas -->
      <ng-template swiperSlide>
        <img
          class="swiperimg webPic"
          src="../../../assets/images/newpartners/logo (3) 2.svg"
        />

        <img
          class="swiperimg mobilePic"
          src="../../../assets/images/newpartners/new/paynas.png"
        />
      </ng-template>

      <!-- iitworks -->

      <ng-template swiperSlide
        ><img
          class="swiperimg webPic"
          src="../../../assets/images/newpartners/image 33.svg"
        />

        <img
          class="swiperimg mobilePic"
          src="../../../assets/images/newpartners/new/itworks.png"
        />
      </ng-template>

      <!-- efinance -->

      <ng-template swiperSlide
        ><img
          class="swiperimg webPic"
          src="../../../assets/images/efinance.svg"
        />

        <img
          class="swiperimg mobilePic"
          src="../../../assets/images//newpartners/new/efinance.png"
        />
      </ng-template>

      <!-- fawry -->

      <ng-template swiperSlide
        ><img
          class="swiperimg webPic"
          src="../../../assets/images/newpartners/fawry-logo-en-last 2.svg"
        />

        <img
          class="swiperimg mobilePic"
          src="../../../assets/images/newpartners/new/fawry.png"
        />
      </ng-template>

      <!-- cairo bank -->

      <ng-template swiperSlide
        ><img
          class="swiperimg webPic"
          src="../../../assets/images/newpartners/BDC_logo 2.svg"
        />

        <img
          class="swiperimg mobilePic"
          src="../../../assets/images/newpartners/new/cairobank.png"
        />
      </ng-template>

      <!-- valu -->

      <ng-template swiperSlide
        ><img
          class="swiperimg webPic"
          src="../../../assets/images/newpartners/valu.svg"
        />

        <img
          class="swiperimg mobilePic"
          src="../../../assets/images/newpartners/new/valu.png"
        />
      </ng-template>

      <!-- opay -->

      <ng-template swiperSlide
        ><img
          class="swiperimg webPic"
          src="../../../assets/images/newpartners/OPay logo-01[83] 2.svg"
        />

        <img
          class="swiperimg mobilePic"
          src="../../../assets/images/newpartners/new/opay.png"
        />
      </ng-template>

      <!-- banqmisr  -->

      <ng-template swiperSlide
        ><img
          class="swiperimg webPic"
          src="../../../assets/images/newpartners/new/banqmisr.svg"
        />

        <img
          class="swiperimg mobilePic"
          src="../../../assets/images/newpartners/new/banqmisr.png"
        />
      </ng-template>

      <!-- paymob  -->

      <ng-template swiperSlide
        ><img
          class="swiperimg webPic"
          src="../../../assets/images/newpartners/paymobLogo 2.svg"
        />

        <img
          class="swiperimg mobilePic"
          src="../../../assets/images/newpartners/new/paymob.png"
        />
      </ng-template>
    </swiper>
  </div>

  <div class="sampleImage"></div>
</div>
